import { AttachmentType } from "../types";

export const getAttachmentType = (mimeType: string): AttachmentType | null => {
  const type = mimeType.split("/")[0];

  switch (type) {
    case "image":
      return AttachmentType.image;
    case "video":
      return AttachmentType.video;
    case "audio":
      return AttachmentType.audio;
    case "application":
    case "text":
      return AttachmentType.file;
    default:
      return null;
  }
};
